import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductDetailView = _resolveComponent("ProductDetailView")!

  return (_openBlock(), _createBlock(_component_ProductDetailView, {
    "page-title": "Lorem ipsum dolor r. r. PROFF",
    "image-url": $data.placeholderImg,
    description: $data.description,
    sections: $data.sections
  }, null, 8, ["image-url", "description", "sections"]))
}